import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import HowToPlay from "@/components/landing/HowToPlay";
import PlayModes from "@/components/landing/PlayModes";
import PowerUps from "@/components/landing/PowerUps";
import CoinBundles from "@/components/landing/CoinBundles";
import PairZeroOut from "@/components/landing/PairZeroOut";
import Betting from "@/components/landing/Betting";
import Waitlist from "@/components/landing/Waitlist";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import CookieConsent from "@/components/landing/CookieConsent";

export default function LandingPage() {
    return (
        <main className="relative">
            <Navbar />
            <Hero />
            <HowToPlay />
            <PlayModes />
            <PowerUps />
            <CoinBundles />
            <PairZeroOut />
            <Betting />
            <Waitlist />
            <FAQ />
            <Footer />
            <CookieConsent />
        </main>
    );
}
